import { useQuery } from '@tanstack/react-query'

import type { Cadencia, Operacao, SaudeBase } from '../types'
import type { FiltroPeriodo } from '@/features/relatorio/api/relatorio-api'

import { api } from '@/lib/api-client'

function paramsDoFiltro(filtro: FiltroPeriodo): Record<string, string> {
  if (filtro.inicio && filtro.fim) return { inicio: filtro.inicio, fim: filtro.fim }
  return { preset: filtro.preset ?? 'mes' }
}

const STALE_MS = 5 * 60_000

export function useSaudeBase(filtro: FiltroPeriodo) {
  const params = paramsDoFiltro(filtro)

  return useQuery({
    queryKey: ['operacao', 'base', params],
    queryFn: async () => {
      const { data } = await api.get<SaudeBase>('/api/relatorio/base', { params })
      return data
    },
    placeholderData: (anterior) => anterior,
    staleTime: STALE_MS,
  })
}

export function useOperacao(filtro: FiltroPeriodo) {
  const params = paramsDoFiltro(filtro)

  return useQuery({
    queryKey: ['operacao', 'operacao', params],
    queryFn: async () => {
      const { data } = await api.get<Operacao>('/api/relatorio/operacao', { params })
      return data
    },
    placeholderData: (anterior) => anterior,
    staleTime: STALE_MS,
  })
}

export function useCadencia(filtro: FiltroPeriodo) {
  const params = paramsDoFiltro(filtro)

  return useQuery({
    queryKey: ['operacao', 'cadencia', params],
    queryFn: async () => {
      const { data } = await api.get<Cadencia>('/api/relatorio/cadencia', { params })
      return data
    },
    placeholderData: (anterior) => anterior,
    staleTime: STALE_MS,
  })
}
